import { Sender } from 'xstate';

import Location from '../../../ports-frontend/Location';
import asyncCallback from '../../../framework/logic/utils/asyncCallback';

export const watchRouteChange = () =>
  asyncCallback(
    async (
      callback: Sender<{ type: 'ROUTE_CHANGED'; data: { location: URL } }>
    ) =>
      Location.onUrlChange((location: URL) => {
        callback({ type: 'ROUTE_CHANGED', data: { location } });
      })
  );
